import { forOwn } from 'lodash-es';
import { Reducer } from 'store/store';
import { ISgmSearchEntities } from 'services/ApiService';

export const initialState = {
    sgmSearch: {} as ISgmSearchEntities,
} as const;

export type NormalizrState = typeof initialState;

export const NormalizrReducer: Reducer<NormalizrState> = (state = initialState, action) => {
    let newState: any;
    switch (action.type) {
        case '@NORMALIZR/MERGE_SGM_SEARCH_ENTITIES':
            newState = mergeEntities(state.sgmSearch, action.payload);
            return {
                ...state,
                sgmSearch: newState,
            };

        case '@NORMALIZR/REMOVE_SGM_SEARCH_ENTITIES':
            newState = removeEntities(state.sgmSearch, action.payload);
            return {
                ...state,
                sgmSearch: newState,
            };

        default:
            return state;
    }
};

type Entities = ISgmSearchEntities;

const removeEntities = (entities: Entities, payload: Entities) => {
    const newState = createNewState(entities);

    forOwn(payload, (value, key) => {
        if (newState[key]) {
            forOwn(value, (_, entityKey) => {
                if (entityKey in newState[key]) {
                    delete newState[key][entityKey];
                }
            });
        }
    });
    return newState;
};

const mergeEntities = (entities: Entities, payload: Entities) => {
    const newState = createNewState(entities);

    forOwn(payload, (value, key) => {
        if (newState[key]) {
            forOwn(value, (entity, entityKey) => {
                newState[key][entityKey] = entity;
            });
        }
        else {
            newState[key] = {
                ...value as object,
            };
        }
    });
    return newState;
};

const createNewState = (state: Entities) => {
    const newState: any = {};
    forOwn(state, (value, key) => {
        newState[key] = {
            ...value as object,
        };
    });
    return newState;
};
